import { apiConfig } from 'config';
import { patchdata } from './PatchData';

export const updateDefaultSWVersion = (data) => {
  const url = apiConfig.swManagerPatchDefaultSWVersion;
  return patchdata(url, data)
    .then((result) => {
      return result;
    })
    .catch((e) => {
      throw e;
    });
};
